import type { FC } from 'react';
import { RuntimeLinkingWrapper } from './RuntimeLinking.styled';
import runtimeLinking1 from '../../../resources/content/runtimeLinking1.png';

interface RuntimeLinkingProps {}

const RuntimeLinking: FC<RuntimeLinkingProps> = () => (
<RuntimeLinkingWrapper>
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Runtime Linking</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">When we execute any program, at that very moment, JVM performs runtime linking. In other words, it will dynamically load, link, and initialize interface and classes.</p>
      <ul className="text-align-justify">
         <li><strong>Loading&nbsp;</strong>is a process in which it finds the binary representation of a class or interface. And with the help of that binary representation, it creates a class or interface.</li>
         <li><strong>Linking</strong>&nbsp;is a process in which it combines a class or an interface into the runtime state of JVM to execute it.</li>
         <li><strong>Initialization&nbsp;</strong>is a process in which it executes the initialization method of a class or interface.</li>
      </ul>

      <div>
         <figure className="aligncenter size-medium">
            <img decoding="async" width="300" height="279" src={runtimeLinking1} alt="" className="lazy-loaded" sizes="(max-width: 300px) 100vw, 300px"  />
         </figure>
      </div>

      <p className="text-align-justify">When we compile a Java program, it will generate a separate class file for each class or an interface. However, the individual class files may appear to be independent. They are connected and have connections to the Java API’s class files.<br />At runtime, Java Virtual Machine loads the program’s classes and interfaces and hooks them together. This entire process is known as dynamic linking or runtime linking.</p>
   </div>
</RuntimeLinkingWrapper>
);

export default RuntimeLinking;
